var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 8 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99998 5.23378C3.8566 5.23378 3.71324 5.18816 3.60393 5.09711L0.164113 2.23057C-0.0547044 2.04822 -0.0547044 1.75257 0.164113 1.5703C0.382842 1.38803 0.737546 1.38803 0.956381 1.5703L3.99998 4.10678L7.04359 1.57039C7.26241 1.38811 7.61708 1.38811 7.83579 1.57039C8.05471 1.75266 8.05471 2.04831 7.83579 2.23066L4.39602 5.0972C4.28666 5.18826 4.1433 5.23378 3.99998 5.23378Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.3518e934c95af8d904a0e68e9b4afda7.svg";
export { ForwardRef as ReactComponent };